import { render } from "./InnerPage.vue?vue&type=template&id=73baed0d&scoped=true"
import script from "./InnerPage.vue?vue&type=script&lang=js"
export * from "./InnerPage.vue?vue&type=script&lang=js"

import "./InnerPage.vue?vue&type=style&index=0&id=73baed0d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73baed0d"]])

export default __exports__